import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, FixedMessage } from '@adc/ui-core'
import classNames from 'classnames/bind'
import cls from './styles.scss'
const cx = classNames.bind(cls)

class Notification extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    elmId: PropTypes.string.isRequired,
    notification: PropTypes.shape({
      text: PropTypes.node.isRequired,
      cta: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
  }

  render() {
    const { notification, elmId, onClose = null } = this.props
    return (
      !!notification && (
        <FixedMessage
          role='notification'
          inlineButton
          notification
          isCloseable
          elmId={`${elmId}_notification`}
          onClose={onClose}
          centered
          showIcon
          className={cx('notification')}
        >
          {notification.text}
          {!!notification.cta && (
            <Button
              role='primary'
              size='small'
              target='_self'
              elmId={`${elmId}_cta`}
              link={notification.cta.href}
            >
              {notification.cta.text}
            </Button>
          )}
        </FixedMessage>
      )
    )
  }
}

const BrowserLink = ({ browser }) => (
  <a href={browser.href} target='_blank' rel='noreferrer'>
    {browser.text}
  </a>
)

BrowserLink.propTypes = {
  browser: PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
}

export default Notification
